import { Injectable } from '@angular/core';
import { InComplianceReportRequest } from 'src/app/model/in-compliance-report-request.model';

@Injectable()
export class VolunteerReportHelperService {
    getReportRequest = ({
        searchBy,
        page,
        limit,
        itemPacket,
        orderBy,
        ascending,
        volunteerAreas,
        getAllResults
    }: {
        searchBy?: string,
        page?: number,
        limit?: number,
        itemPacket?: string,
        orderBy?: string,
        ascending?: boolean,
        volunteerAreas?: string[],
        getAllResults?: boolean
    }) => {
        const request = new InComplianceReportRequest();
        request.SearchBy = searchBy ?? '';
        request.Offset = (page - 1) * limit;
        request.Limit = limit ?? -1;
        request.ItemPacketId = itemPacket ?? "";
        request.OrderBy = orderBy;
        request.Ascending = ascending;
        request.VolunteerAreaIds = volunteerAreas ?? [];
        request.GetAllResults = getAllResults;
        return request;
    }
}